/* global GLightbox */
(function() {
    if (wpk_script_object.lightbox === 'true') {

        //Galleries
        var lightboxGalleries = document.querySelectorAll('main .wp-block-gallery'), i;

        //searchButtons.length > 0
        if(lightboxGalleries) {

            var x = 0;

            //Loop through each gallery cause we need the x value
            for (i = 0; i < lightboxGalleries.length; ++i) {

                ++x;

                //Find all links in a gallery
                var lightboxGalleryLinks = lightboxGalleries[i].querySelectorAll('a[href$=".jpg"]', 'a[href$=".png"]', 'a[href$=".gif"]'), j;
                
                //If we have links inside gallery
                if(lightboxGalleryLinks) {
                
                    //Loop through each link
                    for (j = 0; j < lightboxGalleryLinks.length; ++j) {

                        //Add lightbox selector class
                        lightboxGalleryLinks[j].classList.add('glightbox', 'zoom-in', 'img-rollover');

                        //Add lightbox group attribute
                        lightboxGalleryLinks[j].setAttribute('data-gallery', 'gallery-' + x);

                    }

                }
                
            }

        }

        //Single images
        var lightboxImages = document.querySelectorAll('main .wp-block-image > a[href$=".jpg"]', 'main .wp-block-image > a[href$=".png"]', 'main .wp-block-image > a[href$=".gif"]'), k;

        if(lightboxImages) {

            for (k = 0; k < lightboxImages.length; ++k) {
                lightboxImages[k].classList.add('glightbox', 'zoom-in', 'img-rollover');
                //Add random class so we dont mix single images with gallery images
                lightboxImages[k].setAttribute('data-gallery', Math.floor(Math.random() * 100));
            }

        }

        //Activate lightbox
        // eslint-disable-next-line no-unused-vars
        var wpkLightbox = GLightbox({
            touchNavigation: true,
            loop: true,
            autoplayVideos: true
        });


    }
})();